export const ACCESS_TOKEN_EXPIRATION_BUFFER = 60 * 1000; // 1 minute
